import axios from 'axios';
import { projectApi as api } from './api';
import { ProjectOwner } from 'types/store/projectOwners';
import { JsonApiResponse } from 'types/store/jsonApi';

interface FetchProjectOwnersListParams {
  url: string;
  includeTotalCount?: boolean;
}

export const fetchProjectOwnersList: (
  params: FetchProjectOwnersListParams
) => Promise<JsonApiResponse<ProjectOwner>> = async ({
  url,
  includeTotalCount,
}) => {
  const config = {
    headers: {
      'include-total-count': includeTotalCount ? 'true' : 'false',
    },
  };

  const response = await api.get<JsonApiResponse<ProjectOwner>>(url, config);

  if (axios.isAxiosError(response)) {
    throw response;
  }

  return response.data;
};
